import styled from '../../../theme/styled-with-theme';
import { mediaQueries } from '../../../styles/media-queries';
import { pxToRem } from '../../../styles/utils';

export const Table = styled('table', {
  shouldForwardProp: (prop) => prop !== 'basic'
})<{ basic: boolean }>`
  width: 100%;
  border-collapse: collapse;

  ${({ basic = true }) =>
    basic
      ? ``
      : `
      table-layout: fixed;
      
      &:nth-of-type(even) {
        background-color: #f1f1f1;
      }

      &:nth-of-type(odd) {
        td:nth-of-type(1) {
          width: 35%;
        }

        td:nth-of-type(2) {
          width: 20%;
        }

        td:nth-of-type(3) {
          width: 45%;
        }
      }

      ${mediaQueries.desktop} {
        &:nth-of-type(odd) {
          td:nth-of-type(1) {
            width: 35%;
          }

          td:nth-of-type(2) {
            width: 15%;
          }

          td:nth-of-type(3) {
            width: 50%;
          }
        }
      }

      &:nth-last-of-type(1) {
        background-color: transparent;

        p {
          margin-bottom: ${pxToRem(21)};
        }
      }
  `}
`;

export const HeaderCell = styled('th', {
  shouldForwardProp: (prop) => prop !== 'basic'
})<{ basic: boolean }>`
  background-color: black;
  color: white;
  text-align: left;
  font-weight: normal;
  padding: ${pxToRem(15)};

  ${({ basic = true }) =>
    basic
      ? ``
      : `
        &:nth-of-type(1) {
          width: 35%;
        }

        &:nth-of-type(2) {
          width: 20%;
        }

        &:nth-of-type(3) {
          width: 45%;
        }

        ${mediaQueries.desktop} {
          &:nth-of-type(1) {
            width: 35%;
          }

          &:nth-of-type(2) {
            width: 15%;
          }

          &:nth-of-type(3) {
            width: 50%;
          }
        }
  `}
`;

export const Row = styled('tr')`
  p {
    margin: 0;
  }
`;

export const Cell = styled('td')`
  border: 1px solid #f1f1f1;
  padding: ${pxToRem(15)};

  p {
    word-break: break-word;
  }
`;

export const Paragraph = styled('p')`
  margin-bottom: ${pxToRem(16)};
  font-size: ${({ theme }) => theme.fontSize.s};
  font-weight: normal;
  font-weight: 300;
  line-height: ${pxToRem(28)};

  span {
    font-weight: 600;
  }

  a {
    color: ${({ theme }) => theme.color.inlineAnchor};

    span {
      font-weight: 600;
    }
  }

  ${mediaQueries.desktop} {
    font-size: ${({ theme }) => theme.fontSize.m};
  }
`;
